import { render } from "./batchCheckCompany.vue?vue&type=template&id=d2b3d5be&scoped=true"
import script from "./batchCheckCompany.vue?vue&type=script&lang=js"
export * from "./batchCheckCompany.vue?vue&type=script&lang=js"

import "./batchCheckCompany.vue?vue&type=style&index=0&id=d2b3d5be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2b3d5be"

export default script